import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/autoplay";

const Testimonials = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true });

  const itemVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  const containerVariants = {
    visible: {
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const testimonialsData = [
    {
      text: "Great to attend the inaugural gathering of the MSB Association UK members at Mc Dermott Will & Emery UK LLP, Bishopsgate, yesterday. An initiative bringing together Money Service Business owners and industry professionals for a progressive, resilient and compliant MSB ecosystem for the future. Thanks to keynote speakers... it was a great evening! To the next one! Ad Astra Per Aspera!",
      name: "Giordano Cortese",
      position: "First Rate Exchange Services Ltd. (Senior Manager, Partnerships & Client Acquisition)",
      image: "", // Use a placeholder or a real image
      socials: {
        linkedin: "https://www.linkedin.com/posts/activity-7341775464719433730-AZKI?utm_source=share&utm_medium=member_desktop&rcm=ACoAACNPxx0BWbuSxjsfoVlUlizj-ngx4y6N8DY", // Example link
      },
    },
     {
      text: "First and foremost, I want to say how impressed I was with the inaugural event—it was truly an excellent initiative. Bringing MSBs together under one association to discuss shared challenges and support the industry is a remarkable achievement. I felt honoured to be part of this historic moment.",
      name: "Sampaio Marques",
      position: "GCC (Executive Director)",
      image: "", // Use a placeholder or a real image
      // socials: {
      //   linkedin: "https://www.linkedin.com/posts/activity-7341775464719433730-AZKI?utm_source=share&utm_medium=member_desktop&rcm=ACoAACNPxx0BWbuSxjsfoVlUlizj-ngx4y6N8DY", // Example link
      // },
    },
    {
      text: " I am glad to be the part of MSB Association, Thank you MSB Association. Special Thanks to Ajinkya and Vishal Bhai.",
      name: "Sai Teja",
      position: "Rupy Global Solutions Limited (CEO)",
      image: "", // Use a placeholder or a real image
      // socials: {
      //   linkedin: "https://www.linkedin.com/posts/activity-7341775464719433730-AZKI?utm_source=share&utm_medium=member_desktop&rcm=ACoAACNPxx0BWbuSxjsfoVlUlizj-ngx4y6N8DY", // Example link
      // },
    },
        {
      text: "Hi vishal great event last night congratulations! Well done to you and your team! Speak soon.",
      name: "Harry Deans",
      position: "LinkFX (MSB Development)",
      image: "", // Use a placeholder or a real image
      // socials: {
      //   linkedin: "https://www.linkedin.com/posts/activity-7341775464719433730-AZKI?utm_source=share&utm_medium=member_desktop&rcm=ACoAACNPxx0BWbuSxjsfoVlUlizj-ngx4y6N8DY", // Example link
      // },
    },
     {
      text: "Great Event enjoyed a lot Proud of you",
      name: "Chamika",
      position: "FX Currency London (Director)",
      image: "", // Use a placeholder or a real image
      // socials: {
      //   linkedin: "https://www.linkedin.com/posts/activity-7341775464719433730-AZKI?utm_source=share&utm_medium=member_desktop&rcm=ACoAACNPxx0BWbuSxjsfoVlUlizj-ngx4y6N8DY", // Example link
      // },
    },
    {
      text: "That’s a great initiative, and very nice event.",
      name: "Diego Colucci",
      position: "Real Money Transfer (Data & Operations Manager)",
      image: "", // Use a placeholder or a real image
      // socials: {
      //   linkedin: "https://www.linkedin.com/posts/activity-7341775464719433730-AZKI?utm_source=share&utm_medium=member_desktop&rcm=ACoAACNPxx0BWbuSxjsfoVlUlizj-ngx4y6N8DY", // Example link
      // },
    },
  ];

  return (
    <>
      <section
        className="funfact_section section_space"
        style={{ overflow: "hidden" }}
      >
        <div className="container">
          <div className="heading_block style_2">
            <div className="row align-items-lg-end justify-content-lg-between">
              <motion.div
                ref={sectionRef}
                initial="hidden"
                animate={isInView ? "visible" : "hidden"}
                variants={{
                  hidden: { opacity: 0 },
                  visible: { opacity: 1, transition: { duration: 1 } },
                }}
                className="heading_block style_2 text-center"
              >
                <div className="badge style_2 text-uppercase">
                  <i className="fa-solid fa-circle text-primary"></i> Our
                  Testimonials{" "}
                  <i className="fa-solid fa-circle text-primary"></i>
                </div>
                <h2 className="heading_text mb-0">
                  Celebrating the Experiences of Our Members
                </h2>
              </motion.div>
            </div>
          </div>

          {/* Testimonials Slider */}
          <div className="testimonials">
            <motion.div
              initial="hidden"
              animate={isInView ? "visible" : "hidden"}
              variants={containerVariants}
            >
              <div className="testimonial_slider_wrapper">
                <Swiper
                  modules={[Pagination, Navigation, Autoplay]}
                  spaceBetween={30}
                  slidesPerView={1}
                  navigation={true}
                  autoplay={{ delay: 4000, disableOnInteraction: false }}
                  loop={true}
                  breakpoints={{
                    576: { slidesPerView: 1 },
                    768: { slidesPerView: 1 },
                    1024: { slidesPerView: 1 },
                  }}
                >
                  {testimonialsData.map((item, index) => (
                    <SwiperSlide key={index}>
                      <motion.div
                        className="testimonial_card"
                        variants={itemVariants}
                      >
                        <div>
                          {/* Top content wrapper */}
                          <div className="testimonial_icon">
                            <i className="fas fa-quote-left fa-2x text-primary"></i>
                          </div>
                          <p className="testimonial_text">"{item.text}"</p>
                        </div>
                        <div className="testimonial_footer">
                          {/* New footer wrapper */}
                          <div className="testimonial_user">
                            <img
                              src={
                                item.image ||
                                `https://ui-avatars.com/api/?name=${item.name}&background=000000&color=ffffff&size=60&bold=true`
                              }
                              alt={item.name}
                              className="testimonial_img"
                            />
                            <div>
                              <h6 className="mb-0">{item.name}</h6>
                              <small className="">
                                {item.position}
                              </small>
                              {/* Social Media Links */}
                              {item.socials && (
                                <div className="testimonial_socials">
                                  {item.socials.linkedin && (
                                    <a
                                      href={item.socials.linkedin}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="social_icon"
                                    >
                                      <i className="fab fa-linkedin fa-lg"></i>
                                    </a>
                                  )}
                                  {item.socials.twitter && (
                                    <a
                                      href={item.socials.twitter}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="social_icon"
                                    >
                                      <i className="fab fa-twitter fa-lg"></i>
                                    </a>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Inline CSS */}
      <style jsx="true">{`
        .swiper-slide {
          display: flex;
          height: auto;
        }

        .testimonial_card {
          background: #efefef;
          padding: 30px 50px;
          border-radius: 12px;
          box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
          transition: transform 0.3s ease;
          min-height: 300px;
          height: 100%;
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          margin-bottom: 30px;
          box-sizing: border-box;
        }

        .testimonial_card:hover {
          transform: translateY(-8px);
        }

        .testimonial_icon {
          margin-bottom: 1rem;
        }

        .testimonial_text {
          font-style: italic;
          font-size: 1.2rem;
          color: #444;
          margin-bottom: 1.5rem;
        }

        /* NEW: Footer to align user info and socials */
        .testimonial_footer {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: auto; /* Pushes footer to the bottom */
        }

        .testimonial_user {
          display: flex;
          align-items: center;
        }

        .testimonial_img {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          object-fit: cover;
          margin-right: 15px;
          /* The background color of the image itself is now handled by the API */
        }

        /* NEW: Social Icons styling */
        .testimonial_socials {
          display: flex;
          gap: 15px;
          margin-top: 8px; /* Adds a little space between position and icon */
        }

        .social_icon {
          color: #444;
          transition: color 0.3s ease;
        }

        .social_icon:hover {
          color: #f47c05; /* Your primary color */
        }

        .testimonial_slider_wrapper {
          position: relative;
          padding: 0 50px;
        }

        .swiper-pagination-bullet {
          background-color: #000;
          opacity: 1;
        }

        .swiper-pagination-bullet-active {
          background-color: #f47c05;
        }

        .swiper-button-prev,
        .swiper-button-next {
          color: #000;
          top: 50%;
          transform: translateY(-50%);
          z-index: 10;
        }

        .swiper-button-prev {
          left: -5px;
        }

        .swiper-button-next {
          right: -5px;
        }

        .swiper-button-prev:hover,
        .swiper-button-next:hover {
          color: #f47c05;
        }

        .swiper-button-prev::after,
        .swiper-button-next::after {
          font-size: 24px;
        }

        @media (max-width: 767px) {
          .testimonial_card {
            padding: 20px;
          }

          .testimonial_slider_wrapper {
            padding: 0;
          }

          .swiper-button-prev,
          .swiper-button-next {
            display: none; /* Hide navigation buttons on mobile for more space */
          }

          .testimonial_footer {
            flex-direction: column;
            align-items: flex-start;
            gap: 15px;
          }
        }
      `}</style>
    </>
  );
};

export default Testimonials;